import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function deleteInvoicingAppointment(
  appointmentId: string | number,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/invoicing/delete_appointment/${appointmentId}`,
    {
      method: "DELETE",
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to delete appointment: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
